import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_side-layout/projects')({
  beforeLoad: () => {
    throw redirect({ to: '/home' as string });
  },
});
